export default __webpack_public_path__ + "static/media/triangle.ceda31fc.png";